export const ICON_SIZE = 20;

export const SKELETONS = {
  icon: {
    width: 20,
    height: 14,
  },
};
